/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementDefinition } from './MeasurementDefinition';
import type { Session } from './Session';
/**
 * 
 * @export
 * @interface SessionDefinition
 */
export interface SessionDefinition {
    /**
     * 
     * @type {number}
     * @memberof SessionDefinition
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionDefinition
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionDefinition
     */
    data?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SessionDefinition
     */
    timeEstimate?: number;
    /**
     * 
     * @type {Array<MeasurementDefinition>}
     * @memberof SessionDefinition
     */
    measurementDefinitions?: Array<MeasurementDefinition> | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof SessionDefinition
     */
    sessions?: Array<Session> | null;
}

/**
 * Check if a given object implements the SessionDefinition interface.
 */
export function instanceOfSessionDefinition(value: object): value is SessionDefinition {
    return true;
}

export function SessionDefinitionFromJSON(json: any): SessionDefinition {
    return SessionDefinitionFromJSONTyped(json, false);
}

export function SessionDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'data': json['data'] == null ? undefined : json['data'],
        'timeEstimate': json['timeEstimate'] == null ? undefined : json['timeEstimate'],
        'measurementDefinitions': json['measurementDefinitions'] == null ? undefined : ((json['measurementDefinitions'] as Array<any>).map((require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionFromJSON)),
        'sessions': json['sessions'] == null ? undefined : ((json['sessions'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
    };
}

export function SessionDefinitionToJSON(json: any): SessionDefinition {
    return SessionDefinitionToJSONTyped(json, false);
}

export function SessionDefinitionToJSONTyped(value?: SessionDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'data': value['data'],
        'timeEstimate': value['timeEstimate'],
        'measurementDefinitions': value['measurementDefinitions'] == null ? undefined : ((value['measurementDefinitions'] as Array<any>).map((require('./MeasurementDefinition') as typeof import('./MeasurementDefinition')).MeasurementDefinitionToJSON)),
        'sessions': value['sessions'] == null ? undefined : ((value['sessions'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
    };
}

